import { useRequest } from 'ahooks'
import { Form, Modal } from 'antd'
import React from 'react'
import { useTranslation } from 'react-i18next'

import { JQLEditContent } from '@/components/jql/jql-edit-content.component'
import { ResourceType } from '@/schemas'

import { Production } from '../../production.schema'
import { JiraColumnProps } from './production-jql-table-config.component'

interface ProductionJQLEditProps {
  columns: JiraColumnProps[]
  selfId: string
  jql: string | null
  visible: boolean
  setVisible: React.Dispatch<React.SetStateAction<boolean>>
  onSuccess: (jql: string) => void
  production: Production
}

export const ProductionJQLEdit: React.FC<ProductionJQLEditProps> = ({
  columns,
  selfId,
  jql,
  visible,
  setVisible,
  onSuccess,
  production,
}) => {
  const { t } = useTranslation()
  const [form] = Form.useForm()

  const { run, loading } = useRequest(
    (jql) => ({
      url: `/api/production/patch/${selfId}`,
      method: 'patch',
      data: {
        jql,
      },
    }),
    {
      manual: true,
      onSuccess: (_, [jql]) => {
        onSuccess(jql)
        setVisible(false)
      },
    }
  )

  const onOk = () => {
    form.submit()
  }

  return (
    <Modal
      title={t('configure jql')}
      width='80vw'
      okText={t('save')}
      visible={visible}
      onOk={onOk}
      onCancel={() => setVisible(false)}
      okButtonProps={{ loading }}
    >
      <JQLEditContent
        columns={columns}
        form={form}
        jql={jql}
        onSubmit={run}
        entity={{ name: production.name, type: ResourceType.PRODUCTION }}
      />
    </Modal>
  )
}
